<template>
  <SelectableSearch
    :model-value="props.modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    :options="props.options"
    idKey="id"
    labelKey="vendor_nm"
    :formatter="props.formatter || defaultFormatLabel"
    :getInputLabel="(v) => v?.vendor_nm ?? ''"
    :placeholder="props.placeholder || '業者名またはIDで検索'"
    :required="props.required || false"
  />
</template>

<script setup>
import SelectableSearch from './SelectableSearch.vue'

const props = defineProps({
  modelValue: [String, Number, null],
  options: {
    type: Array,
    required: true
  },
  formatter: Function,
  placeholder: String,
  required: Boolean
})

const emit = defineEmits(['update:modelValue'])

const defaultFormatLabel = (v) => `${v.vendor_nm}（ID: ${v.id}）`
</script>
